/**
 * Argentina phone validation (country code +54)
 * Single input: user enters full number with area code
 * Rules:
 * - 10 digits total (area + number)
 * - No spaces allowed
 * - Leading 0 should be removed
 * - Cannot start with 15
 * - 11 digits only if starts with 9 (mobile), and cannot have 15 after the 9
 */
export function validateArgentinaPhone(
  telefono: string
): { valid: boolean; normalized?: string } {
  const digits = telefono.replace(/\D/g, "").replace(/^0+/, "");

  if (digits.length !== 10 && digits.length !== 11) return { valid: false };
  if (digits.startsWith("15")) return { valid: false };

  if (digits.length === 10) {
    // 10 digits: cannot have 15 after 9 either (e.g. 915... is invalid)
    if (digits[0] === "9" && digits.substring(1, 3) === "15") return { valid: false };
    return { valid: true, normalized: digits };
  }

  // 11 digits: must start with 9 (mobile)
  if (digits[0] !== "9") return { valid: false };
  if (digits.substring(1, 3) === "15") return { valid: false };
  return { valid: true, normalized: digits };
}

/** Normalize phone: digits only, no spaces, remove leading 0 */
export function normalizeArgentinaPhone(telefono: string): string {
  return telefono.replace(/\D/g, "").replace(/^0+/, "");
}
